export default __webpack_public_path__ + "static/media/12-9.dbfab9b2.png";